/**
 * Contentful connector fetch - matches dataProtect ConnectorBar.js
 * Fetches connector list from Contentful CMS with displayOnAppEnvironments and forIntegrationOnly filters.
 * No backend changes - same Contentful space/config as dataProtect.
 */
import { createClient } from 'contentful';

const CONTENTFUL_SPACE = '0qhqhn3xauc3';
const CONTENTFUL_ACCESS_TOKEN = '0f243ce9285ce061d169b5d337e547755168c3972d67dc957df8362b504ccdfd';
const CONNECTOR_CONTENT_TYPE_ID = 'connector';

const contentfulClient = createClient({
  accessToken: CONTENTFUL_ACCESS_TOKEN,
  space: CONTENTFUL_SPACE,
});

export interface ContentfulConnectorEntry {
  sys: {
    id: string;
  };
  fields: {
    title: string;
    providerType: string;
    logo?: {
      fields?: {
        file?: { url?: string };
      };
    };
    relevance?: number;
    forIntegrationOnly?: boolean;
    displayOnAppEnvironments?: boolean;
    categories?: Array<{ fields: { title: string } }>;
  };
}

/**
 * Fetch connectors from Contentful - matches dataProtect ConnectorBar.js componentDidMount
 * - Filters by displayOnAppEnvironments
 * - In production: excludes forIntegrationOnly connectors
 */
export const fetchContentfulConnectors = async (
  isIntegration: boolean
): Promise<ContentfulConnectorEntry[]> => {
  // Contentful Delivery API accepts order: 'fields.title' (dataProtect uses this)

  const entries = await contentfulClient.getEntries({
    include: 3,
    content_type: CONNECTOR_CONTENT_TYPE_ID,
    order: 'fields.title',
  } as any);

  const contentfulTemplates: ContentfulConnectorEntry[] = [];

  for (const o of entries.items as unknown as ContentfulConnectorEntry[]) {
    if (o.fields.logo?.fields?.file?.url) {
      const imgUrl = o.fields.logo.fields.file.url;
      if (!imgUrl.startsWith('https://')) {
        o.fields.logo.fields.file.url = `https:${imgUrl}`;
      }
    }
    if (!o.fields.relevance) {
      (o.fields as { relevance?: number }).relevance = 10;
    }
    if (!isIntegration && o.fields.forIntegrationOnly === true) {
      continue;
    }
    if (o.fields.displayOnAppEnvironments) {
      contentfulTemplates.push(o);
    }
  }

  // Initial sort by relevance (matches dataProtect)
  contentfulTemplates.sort((a, b) => {
    const relA = a.fields.relevance ?? 10;
    const relB = b.fields.relevance ?? 10;
    if (relA < relB) return -1;
    if (relA > relB) return 1;
    return 0;
  });

  return contentfulTemplates;
};
